import { parseCellId } from './cellHelpers';

export const getSelectionRange = (startCell, endCell) => {
  const [startCol, startRow] = parseCellId(startCell);
  const [endCol, endRow] = parseCellId(endCell);

  const selected = [];
  for (
    let i = Math.min(startRow, endRow);
    i <= Math.max(startRow, endRow);
    i += 1
  ) {
    for (
      let j = Math.min(startCol, endCol);
      j <= Math.max(startCol, endCol);
      j += 1
    ) {
      selected.push(`${String.fromCharCode(64 + j)}${i}`);
    }
  }
  return selected;
};
